const requireFields = [
  'payoutCurrency', 'payee', 'entityType',
  'cardNumber', 'swiftCode', 'accountType', '',
  'walletType', 'walletPhone', 'pickUpBankName', 'pickUpBankBranchName',
];

export const getCountryFieldInfo = ({ country, entityType }) => {
  let fields = [];
  switch (country) {
  case 'BR': // 巴西
    fields = ['sortCode', 'branchCode', 'phone', 'vatNumber'];
    break;
  case 'CA': // 加拿大
    fields = ['sortCode', 'branchCode', 'address1', 'address2', 'address3', 'zipCode', 'city', 'state'];
    break;
  case 'EG': // 埃及
    fields = ['address1', 'address2', 'address3'];
    break;
  case 'GB': // 英国
    fields = ['sortCode', 'phone', 'zipCode'];
    break;
  case 'ID': // Indonesia
    fields = ['sortCode', 'branchCode', 'address1', 'address2', 'address3', 'city'];
    if (`${entityType}` === '0') { // 企业
      fields.push('bankHolderName');
    } else if (`${entityType}` === '1') { // 个人
      fields.push('birthDate');
    }
    break;
  case 'JP': // Japan
    fields = ['sortCode', 'branchCode', 'address1', 'address2', 'address3', 'zipCode', 'city'];
    break;
  case 'KR': // Korea
    fields = ['sortCode', 'address1', 'address2', 'address3', 'phone', 'city'];
    break;
  case 'MX': // Mexico
    fields = ['phone'];
    break;
  case 'MY': // Malaysia
    fields = ['phone'];
    break;
  case 'PH': // Philippines
    fields = ['sortCode', 'phone'];
    break;
  case 'SA': // Saudi Arabia
    fields = ['address1', 'address2', 'address3'];
    break;
  case 'TH': // Thailand
    fields = ['address1', 'address2', 'address3', 'phone', 'city'];
    break;
  case 'US': // United States
    fields = ['sortCode', 'address1', 'address2', 'address3', 'zipCode', 'city', 'state'];
    break;
  case 'VN': // Vietnam
    fields = ['branchCode', 'address1', 'address2', 'address3', 'phone'];
    if (`${entityType}` === '1') { // 个人
      fields.push('birthDate');
    }
    break;
  default:
    break;
  }

  if (`${entityType}` === '0') { // 企业
    fields.push('companyName');
  } else if (`${entityType}` === '1') { // 个人
    fields.push('firstName');
    fields.push('lastName');
  }
  return [...requireFields, ...fields];
};

export const PAYER_FIELDS = [{
  key: 'merchantNameEn',
  label: '企业名称-英文',
  value: '',
}, {
  key: 'addressEn',
  label: '英文地址',
  value: '',
}, {
  key: 'merchantName',
  label: '企业名称-中文',
  value: '',
}, {
  key: 'email',
  label: '注册邮箱',
  value: '',
}, {
  key: 'phoneNumber',
  label: '手机号',
  value: '',
}, {
  key: 'country',
  label: '企业注册-国家',
  value: '',
}, {
  key: 'province',
  label: '企业注册-省/州',
  value: '',
}, {
  key: 'city',
  label: '企业注册-城市',
  value: '',
}, {
  key: 'businessLicense',
  label: '营业执照号',
  value: '',
}, {
  key: 'registerDate',
  label: '企业注册日期',
  value: '',
}, {
  key: 'postalCode',
  label: '邮政编码',
  value: '',
}];

export const PAYEE_FIELDS = [{
  key: 'firstName',
  label: '名-FirstName',
  value: '',
}, {
  key: 'lastName',
  label: '姓-LastName',
  value: '',
}, {
  key: 'payee',
  label: '昵称',
  value: '',
}, {
  key: 'companyName',
  label: '公司名称-英文',
  value: '',
}, {
  key: 'state',
  label: '收款方州/省',
  value: '',
}, {
  key: 'city',
  label: '收款方城市',
  value: '',
}, {
  key: 'address1',
  label: '收款方地址-英文',
  value: '',
}, {
  key: 'phone',
  label: '手机号',
  value: '',
}, {
  key: 'zipCode',
  label: '邮政编码',
  value: '',
}, {
  key: 'vatNumber',
  label: '身份证号 / 税号（巴西）',
  value: '',
}, {
  key: 'birthDate',
  label: '出生日期（DOB）',
  value: '',
}, {
  key: 'email',
  label: '邮箱',
  value: '',
}];

export const TXN_FIELDS = [{
  key: 'bankName',
  label: '银行名称',
  value: '',
}, {
  key: 'swiftCode',
  label: 'SwiftCode',
  value: '',
}, {
  key: 'bankHolderName',
  label: '银行账户名',
  value: '',
}, {
  key: 'cardNumber',
  label: '银行账号',
  value: '',
}, {
  key: 'accountType',
  label: '账户类型',
  value: '',
}, {
  key: 'payoutCurrency',
  label: '币种',
  value: '',
}, {
  key: 'sortCode',
  label: '银行代码-BankCode',
  value: '',
}, {
  key: 'branchCode',
  label: '分行编号-BranchCode',
  value: '',
}, {
  key: 'iban',
  label: 'IBAN',
  value: '',
}, {
  key: 'walletType',
  label: '钱包类型',
  value: '',
}, {
  key: 'walletPhone',
  label: '钱包手机号',
  value: '',
}, {
  key: 'pickUpBankBranchName',
  label: '分支机构',
  value: '',
}, {
  key: 'pickUpBankAddress',
  label: '机构地址',
  value: '',
}, {
  key: 'transactionPurpose',
  label: '付款用途',
  value: '',
}, {
  key: 'reference',
  label: '交易附言',
  value: '',
}];
